<app-side-menu>
  <div class="agreements-container">
    <!-- Filtros -->
    <div class="filters-section">
      <div class="filters-row">
        <div class="filter-group">
          <label for="statusFilter" class="form-label">Filtrar por Status:</label>
          <select 
            id="statusFilter" 
            class="form-select" 
            [(ngModel)]="filters.status"
            (change)="onStatusFilterChange(filters.status)">
            <option [value]="null">Todos os status</option>
            <option *ngFor="let status of statusOptions" [value]="status.value">
              {{ status.label }}
            </option>
          </select>
        </div>

        <div class="filter-actions">
          <button 
            type="button" 
            class="btn btn-outline-secondary"
            (click)="clearFilters()">
            <i class="fas fa-times me-2"></i>
            Limpar Filtros
          </button>
        </div>
      </div>
    </div>

    <!-- Tabela de Acordos -->
    <div *ngIf="!error">
      <app-table
        [title]="tableTitle"
        [columns]="columns"
        [data]="agreements"
        [loading]="loading"
        [showSearch]="showSearch"
        [searchPlaceholder]="searchPlaceholder"
        [clickable]="clickable"
        [actions]="actions"
        [enableSorting]="true"
        [clientSideSort]="true"
        [disablePagination]="false"
        [totalItemsFromBackend]="totalItems"
        [searchTerm]="filters.searchTerm"
        (actionClick)="onActionClick($event)"
        (searchChange)="onSearchChange($event)"
        (pageChange)="onPageChange($event)"
        (pageSizeChange)="onPageSizeChange($event)">
        <app-button
          table-header-action
          text="Novo Acordo"
          [color]="'var(--primary-light)'"
          [height]="'42px'"
          className="new-agreement-btn"
          (buttonClick)="newAgreement()">
        </app-button>
      </app-table>
    </div>

<!-- Error Message -->
    <div *ngIf="error" class="alert alert-danger" role="alert">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <i class="fas fa-exclamation-triangle me-2"></i>
          {{ error }}
        </div>
        <button 
          type="button" 
          class="btn btn-outline-danger btn-sm"
          (click)="retryLoad()">
          <i class="fas fa-redo me-1"></i>
          Tentar Novamente
        </button>
      </div>
    </div>
  </div>
</app-side-menu>
